import { SUPPORTED_VIEWER_LANGUAGES } from '../../constants/supported-languages';
export const RTL_LANGUAGES = [
    'ar',
    'arc',
    'bcc',
    'bqi',
    'ckb',
    'dv',
    'fa',
    'glk',
    'ha',
    'he',
    'khw',
    'ks',
    'ku',
    'mzn',
    'pnb',
    'ps',
    'sd',
    'ug',
    'ur',
    'yi',
];
export const FORM_FACTORS = {
    MOBILE: 'Mobile',
    DESKTOP: 'Desktop',
};
export const isSSR = (wixCodeApi) => wixCodeApi.window.rendering.env === 'backend';
export const getIsMobile = (wixCodeApi) => wixCodeApi.window.formFactor === FORM_FACTORS.MOBILE;
export const getSiteLanguage = (wixCodeApi) => {
    const multilingualLanguage = getMultilingualLanguage(wixCodeApi);
    let siteLanguage = wixCodeApi.site.language;
    if (getIsEditor(wixCodeApi)) {
        const query = getQueryParams();
        const regionalLanguage = query.get('regionalLanguage');
        if (regionalLanguage) {
            siteLanguage = regionalLanguage;
        }
    }
    const language = multilingualLanguage || siteLanguage || 'en';
    return SUPPORTED_VIEWER_LANGUAGES.includes(language) ? language : 'en';
};
export const getIsRTL = (wixCodeApi) => {
    const language = getSiteLanguage(wixCodeApi);
    return RTL_LANGUAGES.includes(language);
};
export const getIsEditor = (wixCodeApi) => wixCodeApi.window.viewMode === 'Editor';
export const isSEO = (wixCodeApi) => wixCodeApi.seo.isInSEO();
export const getURL = (wixCodeApi) => wixCodeApi.location.url;
export const getQueryParamValue = (wixCodeApi, queryParam) => wixCodeApi.location.query?.[queryParam];
export const getMultilingualLanguage = (wixCodeApi) => {
    const multilingual = wixCodeApi.window.multilingual;
    return multilingual.isEnabled && multilingual.currentLanguage
        ? multilingual.currentLanguage
        : undefined;
};
export const getMultilingualRegionalFormat = (wixCodeApi) => {
    const currentLanguage = getMultilingualLanguage(wixCodeApi);
    if (!currentLanguage) {
        return;
    }
    return wixCodeApi.window.multilingual.siteLanguages.find((lang) => lang.languageCode === currentLanguage)?.locale;
};
export const getQueryParams = () => {
    if (typeof window !== 'undefined') {
        return new URLSearchParams(window.location.search);
    }
    return new URLSearchParams();
};
export const getRegionalSettings = (wixCodeApi) => getMultilingualRegionalFormat(wixCodeApi) ||
    wixCodeApi.site.regionalSettings ||
    getSiteLanguage(wixCodeApi);
export const getUserData = async (wixCodeApi) => {
    const { currentUser } = wixCodeApi.user;
    if (!currentUser.loggedIn) {
        return;
    }
    let email = '';
    try {
        email = await currentUser.getEmail();
    }
    catch (e) { }
    return {
        id: currentUser.id,
        email,
    };
};
//# sourceMappingURL=wix-code-api.js.map